import { createContext } from 'react';

type PredefinedParam = {
  isUrl?: boolean;
  value: string;
};

export type PredefinedParamsContextValues = {
  getDefsForParam: (paramKey?: string) => PredefinedParam | undefined;
  getFilteredParams: (omitFields: string[]) => PredefinedParam[];
  predefinedParams: PredefinedParam[];
};

const PredefinedParamsContext = createContext<PredefinedParamsContextValues>({
  getDefsForParam: () => void 0,
  getFilteredParams: () => [],
  predefinedParams: [],
});

export default PredefinedParamsContext;
